'use client';
import * as React from 'react';
const tableContext = React.createContext(undefined);
export const tableContextDefaultValue = {
    size: 'medium',
    noNativeElements: false,
    sortable: false
};
export const TableContextProvider = tableContext.Provider;
export const useTableContext = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(tableContext)) !== null && _React_useContext !== void 0 ? _React_useContext : tableContextDefaultValue;
};
